import React, { useState } from 'react';
import { getSessionLogs, formatLogsAsText, SessionLog, getRemoteData } from '../services/logService';
import { formatUsageSummary } from '../services/aiUsageService';
import { generateAuditPdf } from '../services/auditPdfService';

export const AdminLogButton: React.FC = () => {
    const [showPrompt, setShowPrompt] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    const handleAccess = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password.trim() === 'Hycail041266!') {
            setIsFetching(true);
            try {
                // Try to get remote data first
                const remote = await getRemoteData();
                let logs = getSessionLogs();
                let aiSummary = formatUsageSummary();
                let title = "LOCAL SESSION REPORT";

                if (remote && (remote.sessions?.length > 0 || remote.ai_usage?.length > 0)) {
                    logs = remote.sessions || [];
                    aiSummary = formatUsageSummary(remote.ai_usage || []);
                    title = "SYNOLOGY CONSOLIDATED AUDIT";
                }

                if (logs.length === 0 && !remote) {
                    alert("No activity logs found.");
                    setShowPrompt(false);
                    return;
                }

                // Generate & Open Professional PDF (GEA Style)
                generateAuditPdf(logs);

                setShowPrompt(false);
                setPassword('');
            } catch (err) {
                console.error("Audit generation failed:", err);
                alert("Failed to compile audit report.");
            } finally {
                setIsFetching(false);
            }
        } else {
            setError(true);
            setTimeout(() => setError(false), 2000);
        }
    };

    return (
        <div className="fixed bottom-4 left-4 z-[100]">
            {!showPrompt ? (
                <button
                    onClick={() => setShowPrompt(true)}
                    className="w-8 h-8 flex items-center justify-center bg-slate-300 hover:bg-[#0000a9] text-slate-500 hover:text-white border border-slate-500 rounded-none transition-all shadow-lg opacity-40 hover:opacity-100"
                    title="App-AI log"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                </button>
            ) : (
                <div className="bg-slate-300 border border-slate-500 p-6 shadow-2xl animate-fadeIn w-64">
                    <h4 className="text-[10px] font-black uppercase text-slate-900 tracking-widest mb-4">Admin Authentication</h4>
                    <form onSubmit={handleAccess} className="space-y-4">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="SECRET KEY..."
                            autoFocus
                            className={`w-full bg-slate-400 border ${error ? 'border-red-500' : 'border-slate-500 focus:border-[#0000a9]'} p-3 text-xs font-black text-slate-900 outline-none transition-all text-center placeholder-slate-600`}
                        />
                        <div className="flex gap-2">
                            <button
                                type="button"
                                onClick={() => setShowPrompt(false)}
                                className="flex-1 px-3 py-2 bg-slate-400 text-slate-700 font-black text-[9px] uppercase tracking-widest hover:bg-slate-500 transition-all border border-slate-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isFetching}
                                className={`flex-1 px-3 py-2 ${isFetching ? 'bg-slate-500' : 'bg-[#0000a9]'} text-white font-black text-[9px] uppercase tracking-widest hover:bg-[#000080] transition-all`}
                            >
                                {isFetching ? 'Syncing...' : 'Verify'}
                            </button>
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                if (window.confirm("CRITICAL: This will permanently delete all local session and AI usage logs. Are you sure?")) {
                                    localStorage.removeItem('gea_ndt_session_logs');
                                    localStorage.removeItem('gea_ndt_ai_usage');
                                    alert("Local logs purged successfully.");
                                    setShowPrompt(false);
                                }
                            }}
                            className="w-full px-3 py-2 bg-red-600/20 text-red-600 font-black text-[9px] uppercase tracking-widest hover:bg-red-600 hover:text-white transition-all border border-red-600/30"
                        >
                            Clear Local Logs
                        </button>
                        {error && <p className="text-[8px] text-red-600 font-black text-center uppercase tracking-tighter">Access Denied</p>}
                    </form>
                </div>
            )}
        </div>
    );
};
